import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-ssr',
  tagIDKeyName: 'vmid'
});

export default new Router({
    "mode": "history",
    "routes": [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue')
        },
        {
            path: '/sounds',
            name: 'sounds',
            component: () => import('./views/Sounds.vue')
        },
        {
            path: '/sounds/print',
            name: 'print sound list',
            component: () => import('./views/print/Sounds.vue'),
            meta: {
                hideHeader: true,
                hideFooter: true
            }
        },
        {
            path: '/sounds/:mediaKey',
            name: 'sound',
            component: () => import('./views/MediaDetail.vue')
        },
        {
            path: '/stories',
            name: 'stories',
            component: () => import('./views/Stories.vue')
        },
        {
            path: '/stories/print',
            name: 'print story list',
            component: () => import('./views/print/Stories.vue'),
            meta: {
                hideHeader: true,
                hideFooter: true
            }
        },
        {
            path: '/stories/:mediaKey',
            name: 'story',
            component: () => import('./views/MediaDetail.vue')
        },
        {
            path: '/meditations',
            name: 'meditations',
            component: () => import('./views/Meditations.vue')
        },
        {
            path: '/meditations/print',
            name: 'print meditations list',
            component: () => import('./views/print/Meditations.vue'),
            meta: {
                hideHeader: true,
                hideFooter: true
            }
        },
        {
            path: '/meditations/:mediaKey',
            name: 'meditation',
            component: () => import('./views/MediaDetail.vue')
        },
        {
            path: '/journeys',
            name: 'journeys',
            component: () => import('./views/Journeys.vue')
        },
        {
            path: '/journeys/print',
            name: 'print journeys list',
            component: () => import('./views/print/Journeys.vue'),
            meta: {
                hideHeader: true,
                hideFooter: true
            }
        },
        {
            path: '/journeys/:mediaKey',
            name: 'journey',
            component: () => import('./views/MediaDetail.vue')
        },
        {
            path: '/sleepsounds',
            redirect: '/'
        },
        {
            path: '/search',
            name: 'search',
            component: () => import('./views/Search.vue')
        },
        {
            path: '/account',
            name: 'account',
            component: () => import('./views/account/Settings.vue')
        },
        {
            path: '/account/email/verify',
            name: 'verify email',
            component: () => import('./views/account/VerifyEmail.vue')
        },
        {
            path: '/account/email',
            name: 'change email',
            component: () => import('./views/account/settings/Email.vue')
        },
        {
            path: '/account/password',
            name: 'change password',
            component: () => import('./views/account/settings/Password.vue')
        },
        {
            path: '/account/name',
            name: 'change name',
            component: () => import('./views/account/settings/Name.vue')
        },
        {
            path: '/account/playback',
            name: 'playback settings',
            component: () => import('./views/account/settings/Playback.vue')
        },
        {
            path: '/account/notifications/topics',
            name: 'notification settings',
            component: () => import('./views/account/settings/AccountNotificationTopics.vue')
        },
        {
            path: '/account/delete/approve',
            name: 'delete account',
            component: () => import('./views/account/delete/Approve.vue')
        },
        {
            path: '/login/password/reset',
            name: 'password reset',
            component: () => import('./views/PasswordReset.vue')
        },
        {
            path: '/faq',
            name: 'faq',
            component: () => import('./views/Faq.vue')
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import('./views/Contact.vue')
        },
        {
            path: '/careers',
            name: 'careers',
            component: () => import('./views/Careers.vue')
        },
        {
            path: '/press',
            name: 'press',
            component: () => import('./views/Press.vue')
        },
        {
            path: '/premium',
            name: 'premium',
            component: () => import('./views/Premium.vue')
        },
        {
            path: '/alarms',
            name: 'alarms',
            component: () => import('./views/Alarms.vue')
        },
        {
            path: '/alexa',
            name: 'alexa',
            component: () => import('./views/platform/Alexa.vue')
        },
        {
            path: '/alexa/link',
            name: 'alexa-link',
            component: () => import('./views/AlexaLink.vue')
        },
        {
            path: '/alexa/link/result',
            name: 'alexa-link-result',
            component: () => import('./views/AlexaLinkResult.vue')
        },
        {
            path: '/android',
            name: 'android',
            component: () => import('./views/platform/Android.vue')
        },
        {
            path: '/ios',
            name: 'ios',
            component: () => import('./views/platform/iOS.vue')
        },
        {
            path: '/google',
            name: 'google',
            component: () => import('./views/platform/Google.vue')
        },
        {
            path: '/bixby',
            name: 'bixby',
            component: () => import('./views/platform/Bixby.vue')
        },
        {
            path: '/firetv',
            name: 'fire tv',
            component: () => import('./views/platform/FireTV.vue')
        },
        {
            path: '/insider/success',
            name: 'insider-success',
            component: () => import('./views/insider/Success.vue')
        },
        {
            path: '/terms',
            name: 'terms',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import('./views/Terms.vue')
        },
        {
            path: '/privacy',
            name: 'privacy',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import('./views/Privacy.vue')
        },
        {
            path: '/cookies',
            name: 'cookies',
            component: () => import('./views/Cookies.vue')
        },
        {
            path: '/disclaimer',
            name: 'disclaimer',
            component: () => import('./views/Disclaimer.vue')
        },
        {
            path: '/impressum',
            name: 'impressum',
            component: () => import('./views/Impressum.vue')
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if(to.hash){
            return {
                selector: to.hash
            };
        }else if(savedPosition){
            return savedPosition;
        }else{
            return { x: 0, y: 0 };
        }

    }
})
